<template>
    <div class="table" ref="subject">
        <div class="container">
            <div class="handle-box">
                <el-row :gutter="10" type="flex"  justify="start" style="margin-bottom:10px">
                    <el-col  :xs="12" :sm="12" :md="12" :lg="6" :xl="4">
                        <span class="label">开放状态</span>
                        <el-select size="mini" v-model="searchParam.state" clearable placeholder="请选择" class="handle-select">
                            <el-option key="0" label="未开放" value="0"></el-option>
                            <el-option key="1" label="已开放" value="1"></el-option>
                        </el-select>
                    </el-col>
                    <el-col  :xs="12" :sm="12" :md="12" :lg="6" :xl="4">
                        <span class="label">科&emsp;&emsp;目</span>
                        <el-input size="mini" v-model="searchParam.name" placeholder="科目" clearable @clear="searchParam.name = null" class="handle-input"></el-input>
                    </el-col>
                </el-row>
                <el-row type="flex"  justify="end">
                    <el-button size="mini" type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
                    <el-button size="mini" type="primary" icon="el-icon-circle-plus-outline" @click="addVisible = true">添加</el-button>
                    <el-button size="mini" type="primary" icon="el-icon-download" @click="downloadTemplate">试题导入模板</el-button>
                    <!-- <el-upload class="upload" action="/api/manage/user/insertBatch" :multiple=false :show-file-list=false accept=".xls, .xlsx" :before-upload="beforeUpload" :on-success="uploadSuccess" :on-error="uploadError">
                        <el-button type="primary" icon="el-icon-upload2">导入</el-button>
                    </el-upload> -->
                    <!-- <el-button type="primary" icon="el-icon-search" @click="exportRecord">导出</el-button> -->
                </el-row>

                <!-- <el-button type="danger" icon="el-icon-delete" class="handle-del mr10" @click="delAll">批量删除</el-button> -->


                <!-- <el-button type="primary" icon="el-icon-search" @click="getData">搜索</el-button>
                <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addVisible = true">添加</el-button> -->
            </div>
            <el-table :data="tableData" border stripe style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange" :max-height="tableLen">
                <!-- <el-table-column type="selection"></el-table-column> -->
                <el-table-column prop="name" label="科目"></el-table-column>
                <el-table-column prop="price" label="价格(元)" width="85px" align="center"></el-table-column>
                <el-table-column prop="questionCount" label="试卷题数(题)" width="100px" align="center"></el-table-column>
                <el-table-column prop="passScore" label="通过考试分数线" width="120px" :formatter="scoreFormat" align="center"></el-table-column>
                <el-table-column prop="examTime" label="考试时间(分钟)" width="120px" align="center"></el-table-column>
                <el-table-column prop="total" label="已考试总人数" width="100px" align="center"></el-table-column>
                <el-table-column prop="pass" label="通过率" width="80px" align="center" :formatter="passRateFormat"></el-table-column>
                <el-table-column prop="state" label="开放状态" width="85px">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.state == 0" type="primary" disable-transitions>未开放</el-tag>
                        <el-tag v-if="scope.row.state == 1" type="success" disable-transitions>已开放</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="550px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="edit(scope.$index, scope.row)">编辑</el-button>
                        <el-button v-if="scope.row.state === 0" size="mini" type="danger"  @click="enable(scope.$index, scope.row)">开放</el-button>
                        <el-button v-if="scope.row.state === 1" size="mini" type="danger" @click="disable(scope.$index, scope.row)">关闭</el-button>
                        <el-button size="mini" type="primary" @click="selectConfig(scope.$index, scope.row)">设置比例</el-button>
                        <el-button size="mini" type="primary" @click="examConfig(scope.$index, scope.row)">考试设置</el-button>
                        <el-button  size="mini" type="primary" icon="el-icon-download" @click="exportQuestion(scope.$index,scope.row)">导出试题</el-button>
                        <el-upload class="upload"  action="/manage/question/insertBatch" :multiple="false" :data="{subjectId:scope.row.id}"
                            :show-file-list="false" accept=".xls, .xlsx" :before-upload="beforeUpload"
                            :http-request="onUpload">
                            <el-button type="primary"  size="mini" icon="el-icon-upload2">导入试题</el-button>
                        </el-upload>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination @current-change="getData" :current-page.sync="searchParam.pageNum" :page-size.sync="searchParam.pageSize" layout="total,sizes,prev, pager, next" :total="totalNumber">
                </el-pagination>
            </div>
        </div>

        <!-- 单个添加框 -->
        <el-dialog title="添加" :visible.sync="addVisible" width="70%"  @closed="clearValidate('addForm')">
            <el-form ref="addForm" :model="addForm" label-width="150px">
                <el-form-item label="科目名称" prop="name" >
                    <el-input v-model="addForm.name" ></el-input>
                </el-form-item>
                <el-form-item label="全称名称" prop="fullName" >
                    <el-input v-model="addForm.fullName" ></el-input>
                </el-form-item>
                <el-form-item label="证书名称" prop="certificateName" >
                    <el-input v-model="addForm.certificateName" ></el-input>
                </el-form-item>
                <el-form-item label="预约类型" >
                    <el-radio-group v-model="addForm.appointmentType">
                        <el-radio label="non_appointment">非预约</el-radio>
                        <el-radio label="appointment">预约</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="价格" prop="price">
                    <el-input v-model="addForm.price"><template slot="append">元</template></el-input>
                </el-form-item>
                <el-form-item label="考试题目数(题)" prop="questionCount">
                    <el-input-number v-model="addForm.questionCount" ></el-input-number>
                    <!-- <el-input v-model="addForm.questionCount"><template slot="append">题</template></el-input> -->
                </el-form-item>
                <el-form-item label="通过考试分数线(%)" prop="passScore">
                    <el-input-number v-model="addForm.passScore" :precision="1" :step="0.1" :max="100"></el-input-number>
                    <!-- <el-input v-model="addForm.passCount"><template slot="append">题</template></el-input> -->
                </el-form-item>
                <el-form-item label="考试时间(分钟)" prop="examTime">
                    <el-input-number v-model="addForm.examTime" ></el-input-number>
                    <!-- <el-input v-model="addForm.examTime"><template slot="append">分钟</template></el-input> -->
                </el-form-item>
                <el-form-item label="开放状态" prop="state">
                    <el-switch v-model="addForm.state" :active-value=1 :inactive-value=0 active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="图片" prop="imageUrl">
                    <el-upload class="uploadPicture" action="/api/uploadImage" :show-file-list="false" :on-success="uploadPictureSuccess">
                        <img v-if="addForm.imageUrl" :src="addForm.imageUrl"  width="100%">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="考试注意事项" prop="attention">
                    <quill-editor ref="myTextEditor" v-model="addForm.attention" ></quill-editor>
                </el-form-item>
                <el-form-item label="科目简介" prop="introduction">
                    <quill-editor ref="myTextEditor" v-model="addForm.introduction" ></quill-editor>
                </el-form-item>
                <el-form-item label="问卷地址" prop="surveyUrl" >
                    <el-input v-model="addForm.surveyUrl" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveAdd">保 存</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog title="编辑" :visible.sync="editVisible" width="70%" @closed="clearValidate('editForm')">
            <el-form ref="editForm" :model="editForm" label-width="150px">
                <el-form-item label="科目名称" prop="name" >
                    <el-input v-model="editForm.name" ></el-input>
                </el-form-item>
                <el-form-item label="全称" prop="fullName" >
                    <el-input v-model="editForm.fullName" ></el-input>
                </el-form-item>
                <el-form-item label="证书名称" prop="certificateName" >
                    <el-input v-model="editForm.certificateName" ></el-input>
                </el-form-item>
                <el-form-item label="预约类型" >
                    <el-radio-group v-model="editForm.appointmentType">
                        <el-radio label="non_appointment">非预约</el-radio>
                        <el-radio label="appointment">预约</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="价格" prop="price">
                    <el-input v-model="editForm.price"><template slot="append">元</template></el-input>
                </el-form-item>
                <!-- <el-form-item label="考试题目数" prop="questionCount">
                     <el-input v-model="editForm.questionCount"><template slot="append">题</template></el-input>
                </el-form-item> -->
                <!-- <el-form-item label="通过考试答对题目数" prop="passCount">
                    <el-input v-model="editForm.passCount"><template slot="append">题</template></el-input>
                </el-form-item>
                <el-form-item label="考试时间" prop="examTime">
                    <el-input v-model="editForm.examTime"><template slot="append">分钟</template></el-input>
                </el-form-item> -->
                <el-form-item label="考试题目数(题)" prop="questionCount">
                    <el-input-number v-model="editForm.questionCount" ></el-input-number>
                </el-form-item>
                <el-form-item label="通过考试分数线(%)" prop="passScore">
                    <el-input-number v-model="editForm.passScore" :precision="1" :step="0.1" :max="100"></el-input-number>
                </el-form-item>
                <el-form-item label="考试时间(分钟)" prop="examTime">
                    <el-input-number v-model="editForm.examTime" ></el-input-number>
                </el-form-item>
                <el-form-item label="开放状态" prop="state">
                    <el-switch v-model="editForm.state" :active-value=1 :inactive-value=0 active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="图片" prop="imageUrl">
                    <el-upload class="uploadPicture" action="/api/uploadImage" :show-file-list="false" :on-success="uploadPictureInEditSuccess">
                        <img v-if="editForm.imageUrl" :src="editForm.imageUrl" width="100%">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                </el-form-item>
                <el-form-item label="考试注意事项" prop="attention">
                    <quill-editor ref="myTextEditor" v-model="editForm.attention" ></quill-editor>
                </el-form-item>
                <el-form-item label="科目简介" prop="introduction">
                    <quill-editor ref="myTextEditor" v-model="editForm.introduction" ></quill-editor>
                </el-form-item>
                <el-form-item label="问卷地址" prop="surveyUrl" >
                    <el-input v-model="editForm.surveyUrl" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">保 存</el-button>
            </span>
        </el-dialog>

        <el-dialog title="设置抽题数" :visible.sync="subjectConfigVisible" width="600px" @closed="subjectConfigForm = []; configSubject = {}">
            <p>科目：{{configSubject.name}},科目设置试卷题数：{{configSubject.questionCount}},共已设置{{totalCount}}题</p>
            <el-table :data="subjectConfigForm" stripe style="width: 100%">
                <el-table-column prop="domain" label="章节"></el-table-column>
                <el-table-column prop="total" label="题库量"></el-table-column>
                <el-table-column prop="number" label="题数" width="150px">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.number" :min="0" :max="scope.row.total"></el-input-number>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button @click="subjectConfigVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveSubjectConfig">保 存</el-button>
            </span>
        </el-dialog>

        <el-dialog title="考试设置" :visible.sync="examConfigVisible" width="30%"  @closed="clearValidate('examConfigForm')">
            <el-form ref="examConfigForm" :model="examConfigForm" label-width="150px">
                <el-form-item label="允许复制">
                    <el-switch v-model="examConfigForm.allowedCopy"></el-switch>
                </el-form-item>
                <el-form-item label="限制切换">
                    <el-switch v-model="examConfigForm.enableSwitchCount" @change="changeEnableSwitchCount"></el-switch>
                </el-form-item>
                <el-form-item label="警告次数" v-if="examConfigForm.enableSwitchCount">
                    <el-input-number v-model="examConfigForm.maxSwitchCount" :precision="0" :min="0" :step="1" ></el-input-number>
                </el-form-item>
                <el-form-item label="强制交卷" v-if="examConfigForm.enableSwitchCount">
                    <el-switch v-model="examConfigForm.forceCommit" @change="changeForceCommit"></el-switch>
                </el-form-item>
                <el-form-item label="切换次数" v-if="examConfigForm.enableSwitchCount && examConfigForm.forceCommit">
                    <el-input-number v-model="examConfigForm.switchLimit" :precision="0" :min="0" :step="1"></el-input-number>
                </el-form-item>
                <el-form-item label="成绩显示" prop="scoreView">
                    <el-switch v-model="examConfigForm.scoreView" :active-value=1 :inactive-value=0 active-text="立即显示" inactive-text="指定时间" ></el-switch>
                </el-form-item>
                <el-form-item label="时间线" prop="scoreViewTime"  v-if="examConfigForm.scoreView === 0">
                    <el-date-picker v-model="examConfigForm.scoreViewTime" :picker-options="pickerOptions" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" default-time="00:00:00"></el-date-picker>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="examConfigVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveExamConfig">保 存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';
    import { quillEditor } from 'vue-quill-editor';
    export default {
        name: 'subject',
        data() {
            return {
                tableLen:350,
                searchParam:{
                    pageNum:1,
                    pageSize:10
                },
                totalNumber:0,
                tableData: [],//列表中的数据
                multipleSelection: [],
                addVisible:false,
                addBatchVisible:false,
                editVisible: false,
                subjectConfigVisible: false,
                examConfigVisible: false,
                addForm:{
                    name:'',
                    fullName: '',
                    certificateName:'',
                    appointmentType:'non_appointment',
                    price:0,
                    state:0,
                    questionCount:1,
                    passCount:1,
                    passScore:80,
                    examTime:90,
                    imageUrl:''
                },
                editForm:{},
                subjectConfigForm:[],
                examConfigForm:{},
                pickerOptions:{},
                configSubject:{},
                // editOrAddUserRules:{
                //     email:[{required: true, message: '请输入邮箱', trigger: 'blur'}],
                //     chName:[{required: true, message: '请输入姓名', trigger: 'blur'}],
                // },
                uploadInstance:null
            }
        },
        created() {
            this.getData();
        },
        updated() {
            this.tableLen=window.innerHeight-135;
        },
        computed: {
            totalCount() {
                if (this.subjectConfigForm.length == 0) {
                    return 0;
                }
                let sum = 0;
                for (let config of this.subjectConfigForm) {
                    sum += config.number;
                }
                return sum;
            }
        },
        methods: {
            //获取数据
            async getData() {
                let res = await this.$axios.post('/manage/subject/selectByPage',this.searchParam);
                if (res.code == 200) {
                    this.tableData = res.data.list;
                    this.totalNumber = res.data.total;
                } else {
                    this.$message.error(res.errMsg);
                }
            },
            async downloadTemplate() {
                let res = await this.downloadGet('/manage/question/downloadTemplate');
                if (res.code != 200) {
                    this.$message.error("下载失败");
                }
            },

            //新增中的上传图片
            uploadPictureSuccess(res, file, fileList) {
                console.debug(res);
                if (res.code == 200) {
                    this.$set(this.addForm,'pictureUrl', res.data);
                    this.$set(this.addForm,'imageUrl', URL.createObjectURL(file.raw));
                }
            },
            //单条新增科目
            async saveAdd() {
                let valid = await this.$refs.addForm.validate().catch(err=>{return Promise.resolve(false)});
                if (!valid) {
                    return;
                }

                let res = await this.$axios.post('/manage/subject/insert',this.addForm);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }

                this.$refs.addForm.resetFields();
                this.addVisible = false;
                this.$message.success("保存成功");
                this.getData();
            },
            uploadPictureInEditSuccess(res, file, fileList) {
                console.debug(res);
                if (res.code == 200) {
                    this.$set(this.editForm,'pictureUrl', res.data);
                    this.$set(this.editForm,'imageUrl',res.data);
                }
                console.log(this.editForm);
            },
            edit(index, row) {
                this.editForm = this.$ObjectUtil.cloneObj(row);
                this.$set(this.editForm,'imageUrl',row.pictureUrl);
                // this.editForm.imageUrl = row.pictureUrl;
                this.editVisible = true;
            },
            // 保存编辑
            async saveEdit() {
                let valid = await this.$refs.editForm.validate().catch(err=>{return Promise.resolve(false)});
                if (!valid) {
                    return;
                }

                let res = await this.$axios.post('/manage/subject/update',this.editForm);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }

                this.$refs.editForm.resetFields();
                this.editVisible = false;
                this.$message.success("保存成功");
                this.getData();
            },
            async enable(index, row) {
                let res = await this.$axios.get(`/manage/subject/enable/${row.id}`);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                this.getData();
            },
            async disable(index, row) {
                let res = await this.$axios.get(`/manage/subject/disable/${row.id}`);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                this.getData();
            },
            async selectConfig(index, row) {
                let res = await this.$axios.get(`/manage/subject/selectConfig/${row.id}`);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                this.configSubject = row;
                this.subjectConfigForm = res.data;
                this.subjectConfigVisible = true;
            },
            async saveSubjectConfig() {
                console.log(this.subjectConfigForm);
                let total = this.subjectConfigForm.map(obj=> obj.number).reduce((x,y) => x+y);
                if (total != this.configSubject.questionCount) {
                    this.$message.error("设置的题目数错误");
                    return;
                }
                let res = await this.$axios.post(`/manage/subject/updateConfig/${this.configSubject.id}`, this.subjectConfigForm);
                if (res.code != 200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                this.$message.success("保存成功");
                this.subjectConfigVisible = false;
            },
            examConfig(index, row) {
                this.examConfigForm = {
                    id:row.id,
                    scoreView: row.scoreView,
                    scoreViewTime: row.scoreViewTime,
                    enableSwitchCount: row.enableSwitchCount,
                    maxSwitchCount: row.maxSwitchCount,
                    forceCommit: row.switchLimit >= 0,
                    switchLimit: row.switchLimit,
                    allowedCopy: row.allowedCopy,
                };

                this.pickerOptions = row.scoreViewTime == null ? {}:{
                    disabledDate(dateTime) {
                        return dateTime.getTime() < Date.parse(row.scoreViewTime);
                    }
                }

                this.examConfigVisible = true;
            },
            changeEnableSwitchCount(enableSwitch) {
                this.changeForceCommit(enableSwitch)
            },
            changeForceCommit(forceCommit) {
                if (forceCommit) {
                    this.examConfigForm.switchLimit = Math.abs(this.examConfigForm.switchLimit);
                } else {
                    this.examConfigForm.switchLimit = -Math.abs(this.examConfigForm.switchLimit);
                }
            },
            async saveExamConfig() {
                let res = await this.$axios.post('/manage/subject/updateExamConfig', this.examConfigForm);
                if (res.code !== 200) {
                    this.$message.error(res.errMsg);
                    return;
                }
                this.$message.success("保存成功");
                this.examConfigVisible = false;
                this.getData();
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            clearValidate(form) {
                this.$refs[form].resetFields();
            },
            async exportQuestion(index, row) {
                let password = await this.$prompt("请输入独立密码","权限鉴定",{inputPattern:/^\w+$/, inputErrorMessage:'密码格式不正确'}).catch(err=>{return Promise.resolve(null)});
                if (!password) {
                    return;
                }
                let handler = this.$loading({lock:true, text:'导出处理中……', background: 'rgba(0, 0, 0, 0.7)'});
                let res = await this.downloadPost(`/manage/question/exportQuestion/${row.id}`, {password:password.value});
                if (res.code !== 200) {
                    this.$message.error(`导出失败：${res.errMsg}`);
                }
                handler.close();
            },
            //导入试题
            async onUpload(param) {
                let password = await this.$prompt("请输入独立密码","权限鉴定",{inputPattern:/^\w+$/, inputErrorMessage:'密码格式不正确'}).catch(err=>{return Promise.resolve(null)});
                if (!password) {
                    return;
                }
                let formData = new FormData();
                formData.append('file',param.file);
                formData.append('subjectId', param.data.subjectId);
                formData.append('password', password.value);
                this.uploadInstance = this.$loading({lock:true, text:'上传处理中……', background: 'rgba(0, 0, 0, 0.7)'});
                this.$axios.post(param.action, formData).then(res => {
                    this.uploadInstance.close();
                    res.code === 200?  this.$message.success("上传处理成功") : this.$message.error(res.errMsg);
                }).catch(err => {
                    this.uploadInstance.close();
                    this.$message.error('上传处理失败');
                });
            },
            beforeUpload(file) {
                let validate = false;
                if (file && file.name) {
                    let name = file.name;
                    let ext = name.substring(name.lastIndexOf(".")+1, name.length);
                    if (ext == "xls" || ext == "xlsx") {
                        validate = true;
                    }
                }
                if (!validate) {
                    this.$message.error("只能上传'.xls'或者'.xlsx'文件");
                    return;
                }

                if (file.size / 1024 / 1024 > 2) {
                    this.$message.error("只能上传小于2M的文件");
                    return false;
                }
            },
            scoreFormat(row, column, score) {
                if (score !== null) {
                    return score + "%";
                } else {
                    return;
                }
            },
            passRateFormat(row, column, pass) {
                if (row.total == 0) {
                    return '';
                }
                return (pass/row.total * 100).toFixed(2) + '%';
            }
        },
        components:{
            quillEditor
        }
    }

</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 200px;
}

.handle-input {
    width: 200px;
    /* display: inline-block; */
}
.label {
    margin-right: 10px;
    color: #606266;
}
.action {
    display: inline;
    /* float: left; */
}
.action:first-child {
    margin-right: 5px;
}

.upload {
    display: inline;
    margin-left: 10px;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 400px;
    height: 300px;
    line-height: 300px;
    text-align: center;
}
.avatar {
    width: 400px;
    height: 300px;
    display: block;
}
</style>
<style>
.upload > .el-upload--text {
    display: inline;
}
.uploadPicture > .el-upload--text {
    width: 400px;
    height: 300px;
    line-height: 0px;
}
</style>
